import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '../../../shared/services/user.service';

@Component({
  selector: 'app-confirmation-page',
  templateUrl: './confirmation-page.component.html',
  styleUrls: ['./confirmation-page.component.scss']
})
export class ConfirmationPageComponent implements OnInit {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private UserService: UserService
  ) { }
  sub: any;
  confirmationToken: string;

  ngOnInit() {
    this.sub = this.route.queryParams.subscribe(params => {
      this.confirmationToken = params['confirmation_token'];
      this.UserService.sendConfirmation(this.confirmationToken)
        .subscribe(res => {
          window.analytics.track("Self-Signup User Registraion Confirmed");
          this.router.navigate(['/', 2])
        }, err => {
          let error: string = JSON.parse(JSON.parse(err._body).flash)[0][1];
          window.analytics.track("Self-Signup User Registraion Confirmation Failed", {reason: error });
          if (error.includes("Confirmation token is invalid")) {
            this.router.navigate(['/', 6])
          }
          else if (error.includes("Email needs to be confirmed within about 1 month, please request a new one")) {
            this.router.navigate(['/', 7])
          }
          else if (error.includes("Email was already confirmed, please try signing in")) {
            this.router.navigate(['/', 3])
          }
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/confirmation-page/confirmation-page.component.ts